import React, { Component, Fragment } from 'react';

import ResetPassword from './ResetPassword';

import passwordResetRemote from '../../api/passwordResetRemote';
import { connect } from 'react-redux';
import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';
import ResponseError from '../../models/ResponseError';
import { fetchPending, fetchFinish } from '../../store/actions/fetchingAction';
import { UserRoleType } from '../../models/User';
import forwarderReqHandler from '../../api/forwarderRemote';
import ghaReqHandler from '../../api/ghaRemote';

interface ResetPasswordProps { 
  receiveError: Function;
  receiveSuccess: Function;
  fetchPending: Function;
  fetchFinish: Function;
};

interface ResetPasswordState {
  input: {
    forgottenPasswordOption: string;
    email: string;
    password: string;
    confirmPassword: string;
    pin: string;
    manualCompanyId: number;
    companyType: UserRoleType.GHA | UserRoleType.FORWARDER;
    manualFirstName: string;
    manualLastName: string;
  };
  companies: {id: number, name: string}[];
  token: string;
  showSmsDetails: boolean;
  codeModalOpen: boolean;
  disableCodeModalOpen: boolean;
  showManualResetSuccessMessage: boolean;
};

class ResetPasswordContainer extends Component<ResetPasswordProps, ResetPasswordState> {

  state: ResetPasswordState = {
    input: {
      forgottenPasswordOption: 'sms',
      email: '',
      password: '',
      confirmPassword: '',
      pin: '',
      manualCompanyId: 0,
      manualFirstName: '',
      manualLastName: '',
      companyType: UserRoleType.GHA,
    },
    companies: [],
    token: '',
    codeModalOpen: false,
    disableCodeModalOpen: false,
    showSmsDetails: false,
    showManualResetSuccessMessage: false,
  }

  componentDidMount() {
    this.getCompanies(this.state.input.companyType);
  }

  getCompanies = (value: UserRoleType.FORWARDER | UserRoleType.GHA) => {
    let inputState = {...this.state.input};
    inputState.companyType = value;
    if(value === UserRoleType.FORWARDER) {
      forwarderReqHandler.getForwarders({}).then(req => {
        if(req.result) {
          inputState.manualCompanyId = req.result[0].id;
          this.setState({companies: req.result, input: inputState});
        }
        else
          this.props.receiveError(req.error);
      });
      return;
    }

    ghaReqHandler.getGHAs().then(req => {
      if(req.result) {
        inputState.manualCompanyId = req.result[0].id;
        this.setState({companies: req.result, input: inputState});
      }
      else
        this.props.receiveError(req.error);
    }); 
  }

  onFieldChange = (event: any, value?: string) => {
    let inputState: any = {...this.state.input};
    inputState[event.target.name] = event.target.value;
    this.setState({ input: inputState });
    if(event.target.name === 'companyType') {
      this.getCompanies(event.target.value);
    }
  }

  sendSMS = (e: Event) => {
    e.preventDefault();
    this.props.fetchPending();
    passwordResetRemote.resetSmsPasswordRequest({email: this.state.input.email}).then(resp => {
        if(resp.error) {
          this.props.receiveError(resp.error);
        }

        if(resp.result) {
          this.setState({codeModalOpen: true, token: resp.result.token});
        }
        this.props.fetchFinish();
    });
  }

  sendManualRequest = (e: Event) => {
    e.preventDefault();
    this.props.fetchPending();
    let data: any = {};
    
    if(this.state.input.companyType === 'gha')
      data.idGha = this.state.input.manualCompanyId;
    else
      data.idFwd = this.state.input.manualCompanyId;
    
    data.firstName = this.state.input.manualFirstName;
    data.lastName = this.state.input.manualLastName;
    
    passwordResetRemote.resetManualPasswordRequest(data).then(resp => {
        if(resp.error) {
          this.props.receiveError(resp.error);
        }

        if(resp.success) {
          this.setState({showManualResetSuccessMessage: true});
          setTimeout(() => window.location = '/login' as any, 3000);
        }
        this.props.fetchFinish();
    });
  }

  changePassword = (e: Event) => {
    e.preventDefault();
    this.props.fetchPending();
    passwordResetRemote.submitSmsPinWithNewPassword({
      password: this.state.input.password,
      confirmPassword: this.state.input.confirmPassword,
      token: this.state.token,
      pin: this.state.input.pin,
    }).then(resp => {
      if(resp.error) {
        this.props.receiveError(resp.error);
      }

      if(resp.success) {
        this.props.receiveSuccess("Successfully changed you password.")
        window.location = '/login' as any;
      }
      this.setState({showSmsDetails: false, codeModalOpen: false, disableCodeModalOpen: false});
      this.props.fetchFinish();
    })
  }

  onVerification = (e: any) => {
    e.preventDefault();
    this.props.fetchPending();
    passwordResetRemote.verifyResetPasswordRequestCode(this.state.token, this.state.input.pin).then(resp => {
      if(resp.error) {
        this.props.receiveError(resp.error);
        this.setState({codeModalOpen: false});
      }

      if(resp.success) {
        this.setState({showSmsDetails: true});
        this.setState({disableCodeModalOpen: true});
      }
      this.props.fetchFinish();
    });
  }

  render() {

    return (
      <Fragment>
        <ResetPassword
          forgottenPasswordOption={this.state.input.forgottenPasswordOption}
          emailField={this.state.input.email}
          pinCode={this.state.input.pin}
          password={this.state.input.password}
          companies={this.state.companies}
          companyType={this.state.input.companyType}
          manualCompanyId={this.state.input.manualCompanyId}
          manualFirstName={this.state.input.manualFirstName}
          manualLastName={this.state.input.manualLastName}
          confirmPassword={this.state.input.confirmPassword}
          showSmsDetails={this.state.showSmsDetails}
          showSmsCodeDetails={this.state.codeModalOpen}
          disableCodeFields={this.state.disableCodeModalOpen}
          showManualResetSuccessMessage={this.state.showManualResetSuccessMessage}
          sendSMS={this.sendSMS}
          sendManualRequest={this.sendManualRequest}
          changePassword={this.changePassword}
          onSmsCodeVerification={this.onVerification}
          onFieldChange={this.onFieldChange}
        />
      </Fragment>
    );
  }

};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (err: ResponseError) => dispatch(receiveError(err)),
    receiveSuccess: (m: string) => dispatch(receiveSuccess(m)),
    fetchPending: () => dispatch(fetchPending()),
    fetchFinish: () => dispatch(fetchFinish()),
  };
}

export default connect(null, mapDispatchToProps)(ResetPasswordContainer);